/**
 * 资源接口，附件
 */
import Axios from '@/components/api/axios.js'

export default {
	/**
	 * 资源路径列表
	 */
	getPathList: (success, failure) => {
		Axios.post('/resources/getPathList.do', {}, success, failure);
	},
	/**
	 * 查询资源文件
	 */
	findResourcesById: (pkid, success, failure) => {
		Axios.post('/resources/findResourcesById.do', {
			pkid
		}, success, failure);
	},
	/**
	 * 批量查询资源文件
	 */
	findResourcesByIds: (ids, success, failure) => {
		Axios.post('/resources/findResourcesByIds.do', {
			ids
		}, success, failure);
	},
	/**
	 * 通过二进制流提交文件
	 */
	/**
	 * 上传文件
	 * @param {Object} file 整个文件,后台用MultipartFile接收
	 * @param {Object} type 类型
	 */
	uploadByBytes: (formData, success, failure) => {
		Axios.post('/resources/uploadByBytes.do',
			formData, respon => {
				success(respon)
			}, failure, {
				headers: {
					'Content-Type': 'multipart/form-data',
				}
			});
	},
	/**
	 * 查询图片资源集合
	 * @param {String} pkids 资源id，必填，多个用逗号隔开
	 */
	searchOrderPicture: (pkids, success, failure) => {
		Axios.post('/orderMessage/searchOrderPicture.do', {
			pkids
		}, success, failure);
	},
}
